import React from 'react';
import { ChevronRight } from 'lucide-react';

const Breadcrumb = ({ locations = [], currentLocation = 0, onChange = () => { } }) => {

    return (
        <div className="flex flex-row items-center">
            {locations.map((location, index) => (
                <div key={index} className="flex flex-row items-center">
                    <button
                        className={`text-sm text-blue-600 font-medium`}
                        onClick={() => onChange(index)}
                    >
                        {location}
                    </button>
                    {index < locations.length - 1 && (
                        <ChevronRight className="mx-2 h-4 w-4 text-blue-600" />
                    )}
                </div>
            ))}
        </div>
    )
}

export default Breadcrumb;